<template>
  <a :href="link" target="_blank" class="app-link">
    <Icon path="app" :name="type"/>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from '@/components/icon'

export default {
  name: 'AppLink',
  components: {
    Icon
  },
  props: {
    type: {
      type: String,
      default: 'google'
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'platform',
      'downloadLink'
    ]),
    link() {
      return this.downloadLink[this.type]
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');
  .app-link {
    width: 135px;
    height: 40px;
    display: flex;
    align-items: center;
    .i-icon {
      width: 100%;
      height: 100%;
    }
  }
</style>